// extracted by mini-css-extract-plugin
export default {"management-widget-open":"src_management-widget-open__iZ++J"};